export default class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    if (this.hasDismissed) return this.hideElement();
    // Otherwise reveal element and attach click listener to button.
    this.showElement();
    this.bindDismissClick();

    if (Shopify.designMode) this.style.setProperty("position", "fixed");
  }

  get dismissButton() {
    return this.querySelector(".c-announcement-bar__dismiss");
  }

  get storageKey() {
    return "hasDismissedAnnouncement";
  }

  get storageValue() {
    return sessionStorage.getItem(this.storageKey);
  }

  get hasDismissed() {
    return this.storageValue === "true";
  }

  showElement() {
    this.removeAttribute("hidden");
  }

  hideElement() {
    this.setAttribute("hidden", "");
  }

  bindDismissClick() {
    if (!this.dismissButton) return;
    this.dismissButton.addEventListener("click", this.doDismiss);
  }

  doDismiss = () => {
    sessionStorage.setItem(this.storageKey, true);
    this.hideElement();
  };
}
